export default __webpack_public_path__ + "static/media/t1Sala2.72d0fc37.jpg";